var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimeraAngosturaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 49,
    viewBox: "0 0 58 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9283 7.15519L27.0992 5.49536L2 30.7573L6.98599 35.4113C6.98599 35.4113 11.8027 33.5823 13.6318 36.4072C13.6318 36.4072 15.4609 38.067 13.6318 42.3891L18.9498 47.3751L22.0221 44.3028",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.304 29.091L39.2322 2L44.7194 6.98599C44.7194 6.98599 41.0613 11.972 47.5444 13.801C47.5444 13.801 49.7054 13.801 51.0333 12.6359L55.85 17.6219L28.9283 45.5461L23.4411 40.3973C23.4411 40.3973 26.253 36.7262 22.4322 33.5693C22.4322 33.5693 19.9522 31.7532 16.7953 34.0835L12.304 29.091Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.2018 23.773L46.8739 22.6079",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.7129 20.1149L42.3891 18.1231",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.8961 15.9621L37.2339 13.4691",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.0728 10.9761L32.7686 8.50262",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeraAngosturaIcon);
export default __webpack_public_path__ + "static/media/primera-angostura-icon.d44da57d2faba2ef34601ce2b3ac338c.svg";
export { ForwardRef as ReactComponent };